export enum Partners {
  ENROLY_VT = 'EnrolyVT',
}
